import { formatAxisLabel } from './format-axis-label';

const escapeHtml = (value: unknown): string =>
    String(value ?? '').replace(
        /[&<>"']/g,
        (character) =>
            ({
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#39;'
            })[character] ?? character
    );

export interface ChartTooltipSeriesItem {
    name?: string;
    value: unknown;
    color?: string;
}

export const buildChartPointTooltipHtml = (
    label: string,
    value: unknown,
    seriesName?: string,
    seriesNameLabel?: string,
    formatLabel = formatAxisLabel
): string => {
    const day = escapeHtml(formatLabel(String(label)));
    const seriesLabel = seriesName
        ? `<div class="text-foreground-muted flex gap-1 px-2 pt-2 text-xs">
            ${seriesNameLabel ? `<span class="font-medium">${escapeHtml(seriesNameLabel)}:</span>` : ''}
            <span>${escapeHtml(seriesName)}</span>
        </div>`
        : '';

    return `<div class="bg-background-surface outline-border-default rounded-md">
        <div class="text-foreground-default border-b border-b-border-default p-2 bg-background-default/50 w-full text-sm font-semibold">${day}</div>
        ${seriesLabel}
        <div class="text-foreground-muted p-2 text-xs">${escapeHtml(value)}</div>
    </div>`;
};

export const buildChartSharedPointTooltipHtml = (
    label: string,
    series: ChartTooltipSeriesItem[],
    seriesNameLabel?: string,
    formatLabel = formatAxisLabel
): string => {
    const day = escapeHtml(formatLabel(String(label)));
    const rows = series
        .filter((item) => item.value != null)
        .map((item) => {
            if (!item.name) {
                return `<div class="text-foreground-default text-xs font-medium">${escapeHtml(item.value)}</div>`;
            }

            return `<div class="flex items-center justify-between gap-4 text-xs">
                <span class="text-foreground-muted flex min-w-0 items-center gap-2">
                    ${item.color ? `<span class="inline-block h-2 w-2 shrink-0 rounded-full" style="background-color: ${escapeHtml(item.color)}"></span>` : ''}
                    <span class="truncate">${escapeHtml(item.name)}</span>
                </span>
                <span class="text-foreground-default font-medium">${escapeHtml(item.value)}</span>
            </div>`;
        })
        .join('');

    return `<div class="bg-background-surface outline-border-default rounded-md">
        <div class="text-foreground-default border-b border-b-border-default p-2 bg-background-default/50 w-full text-sm font-semibold">${day}</div>
        <div class="space-y-1 p-2">
            ${seriesNameLabel ? `<div class="text-foreground-muted pb-1 text-xs font-medium">${escapeHtml(seriesNameLabel)}</div>` : ''}
            ${rows}
        </div>
    </div>`;
};
